import { useTheme } from '@emotion/react';
import { Flex, Skeleton } from '@mantine/core';

import dt from '~/testing';

type HomeSkeletonLayoutProps = {
  isLoading: boolean;
  order: number;
};

function HomeSkeletonLayout({ isLoading, order }: HomeSkeletonLayoutProps) {
  const theme = useTheme();

  return (
    <Flex data-test-id={dt.home.components.homeSkeleton} direction="column" gap={theme.spacing.sm} style={{ order }}>
      <Skeleton h={40} visible={isLoading} />
      <Skeleton mih={170} visible={isLoading} />
    </Flex>
  );
}

export default HomeSkeletonLayout;
